export default __webpack_public_path__ + "static/media/pg_logo.c5adf825.jpg";